exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.live-main iframe:first-child {\n  height: 600px;\n}\n\n@media screen and (max-width: 767px) {\n\n  .live-main iframe:first-child {\n    height: 250px;\n  }\n}", ""]);

// exports
